import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/hacker.jpg'


const _withScopeId = n => (_pushScopeId("data-v-c99addb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex font-montserrat flex-col justify-center items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lg:h-[80px] h-[50px]" }, null, -1))
const _hoisted_3 = { class: "container flex flex-col justify-center items-center max-w-[1024px] md:my-[50px] my-[25px] py-[20px] px-[10px] w-full" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "md:text-3xl text-xl font-semibold text-center uppercase text-black" }, "Formation en cybersécurité", -1))
const _hoisted_5 = { class: "w-full relative my-[25px] md:my-[50px] flex justify-center items-center" }
const _hoisted_6 = { class: "w-full relative" }
const _hoisted_7 = { class: "w-full relative flex justify-center items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  value: "Rechercher",
  type: "submit",
  class: "bg-cyan-500 cursor-pointer text-white font-semibold border border-cyan-500 text-sm md:px-[30px] md:p-[20px] px-[15px] p-[10px]"
}, null, -1))
const _hoisted_9 = { class: "w-full relative md:text-justify md:p-[50px] p-[20px] text-gray-700 bg-gray-100" }
const _hoisted_10 = { class: "container max-w-[1024px] py-[20px] mb-[150px] px-[10px] w-full" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[50px] h-[4px] bg-[#427E7E]" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "uppercase text-[#427E7E] text-2xl font-bold my-[10px]" }, "Nos programmes de formations", -1))
const _hoisted_13 = { class: "flex md:justify-start justify-center items-center flex-wrap" }
const _hoisted_14 = { class: "text-cyan-500 font-bold text-xl" }
const _hoisted_15 = { class: "text-xs my-[5px]" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Durée : ", -1))
const _hoisted_17 = { class: "text-xs my-[5px]" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Métier visé : ", -1))
const _hoisted_19 = { class: "text-xs my-[5px]" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Certification cible : ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute en1 top-0 left-0 right-0 duration-300 ease-in-out w-full h-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "w-full h-full"
  })
], -1))
const _hoisted_22 = { class: "absolute en2 top-0 left-0 right-0 duration-300 ease-in-out w-full p-[25px] bg-black/25 flex flex-col justify-end items-center h-full" }
const _hoisted_23 = { class: "text-center font-bold text-white" }
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"m-[10px] cursor-not-allowed md:w-[300px] md:h-[300px] w-[265px] h-[265px] border bg-[url(&#39;./img/logo.png&#39;)] bg-cover bg-no-repeat bg-center p-[20px] flex flex-col justify-center items-center relative transition-opacity\" data-v-c99addb6><h1 class=\"text-center uppercase text-sm z-10 font-semibold\" data-v-c99addb6>Bientôt disponible</h1><p class=\"text-xs my-[5px]\" data-v-c99addb6></p><p class=\"text-xs my-[5px]\" data-v-c99addb6></p><p class=\"text-xs my-[5px]\" data-v-c99addb6></p><div class=\"absolute top-0 left-0 backdrop-blur-lg right-0 duration-300 ease-in-out w-full h-full\" data-v-c99addb6></div><div class=\"absolute top-0 left-0 right-0 hidden duration-300 ease-in-out w-full p-[25px] bg-black/25 flex-col justify-end items-center h-full\" data-v-c99addb6><h1 class=\"text-center font-bold text-white\" data-v-c99addb6></h1></div></div>", 1)

import HeaderComponent from '../components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormationAll',
  setup(__props) {

const router = useRouter()

// Données des formations
const formations = ref([
    { id: "cybersecurity", title: "Formation complète en cybersécurité et préparation à la certification CompTIA Security+", duration: "12 semaines", job: "Analyste en cybersécurité", certification: "CompTIA’s Security+" },
    // Ajoutez d'autres formations ici...
]);

// Recherche des formations
const searchQuery = ref('');
const filteredFormations = ref([]);

const searchFormations = () => {
    filteredFormations.value = formations.value.filter(formation =>
        formation.title.toLowerCase().includes(searchQuery.value.toLowerCase())
    );
}

onMounted(() => {
    filteredFormations.value = formations.value; // Charger toutes les formations au démarrage
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
              onInput: searchFormations,
              class: "w-full border md:px-[30px] md:p-[20px] border-l-none outline-none focus:shadow-4xl text-sm px-[15px] p-[10px]"
            }, null, 544), [
              [_vModelText, searchQuery.value]
            ]),
            _hoisted_8
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_9, " La digitalisation prend de plus en plus de l'ampleur et elle s’accompagne des risques cybernétiques. Comment se protéger? C’est en réponse à ce besoin grandissant que IronSecur propose un programme de formation alliant compétences théoriques et pratiques pour former des experts capables de faire face à ces défis. L'engagement éthique de cette mission vous amène à vous mettre au service d'entreprises traitant des données sensibles ou fournissant des services en cybersécurité. Dans le cadre de notre programme, une immersion en entreprise est prévue pour vous préparer à cette réalité professionnelle. Chez IronSecur nous faisons de vous des acteurs prêts à contrer les cyberattaques. ", 512), [
        [_vShow, searchQuery.value.length === 0]
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFormations.value, (formation) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: formation.id,
            to: '/training-' + formation.id,
            class: "m-[10px] pa md:w-[300px] md:h-[300px] w-[265px] h-[265px] shadow-4xl bg-white p-[20px] flex flex-col justify-center items-start relative transition-opacity duration-500 ease-linear hover:opacity-75"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h1", _hoisted_14, _toDisplayString(formation.title), 1),
              _createElementVNode("p", _hoisted_15, [
                _hoisted_16,
                _createTextVNode(" " + _toDisplayString(formation.duration), 1)
              ]),
              _createElementVNode("p", _hoisted_17, [
                _hoisted_18,
                _createTextVNode(" " + _toDisplayString(formation.job), 1)
              ]),
              _createElementVNode("p", _hoisted_19, [
                _hoisted_20,
                _createTextVNode(" " + _toDisplayString(formation.certification), 1)
              ]),
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("h1", _hoisted_23, _toDisplayString(formation.title), 1)
              ])
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128)),
        _hoisted_24
      ])
    ]),
    _createVNode(FooterComponent)
  ]))
}
}

})